import moment from "moment";
// eslint-disable-next-line no-unused-vars
import * as Types from "../CreditMonitoring.types";
/**
 * @param {Types.UserInfo} user
 * @returns {{ error: string, isValid: boolean }} The result object containing an error message if any, and a validity flag.
 */
export const validatePersonalInfo = (user) => {
  const requiredFields = ["firstName", "lastName", "dateOfBirth", "ssn", "phoneNumber"];
  const requiredAddressFields = ["street", "city", "state", "zip"];
  const missingFieldErrors = {
    firstName: "First name is required",
    lastName: "Last name is required",
    dateOfBirth: "Date of birth is required",
    ssn: "SSN is required",
    phoneNumber: "Phone number is required",
    street: "Street is required",
    city: "City is required",
    state: "State is required",
    zip: "Zip is required",
  };

  // Check for missing required fields
  const missingFields = requiredFields.filter((field) => !user[field]);

  // Check for missing required address fields
  const missingAddressFields = requiredAddressFields.filter(
    (field) => !user.address || !user.address[field],
  );

  // Combine the missing fields
  const allMissingFields = missingFields.concat(missingAddressFields);

  // If there are any missing fields, return the first error
  if (allMissingFields.length > 0) {
    return {
      error: missingFieldErrors[allMissingFields[0]],
      isValid: false,
    };
  }

  if (
    !moment(user.dateOfBirth, "MM/DD/YYYY").isValid() ||
    moment().diff(moment(user.dateOfBirth, "MM/DD/YYYY"), "years") < 18
  ) {
    return {
      error: "You must be at least 18 years old to use this service",
      isValid: false,
    };
  }

  // Check SSN length after removing any non-digit characters
  const sanitizedSSN = user.ssn.replace(/\D/g, "");
  if (sanitizedSSN.length !== 9) {
    return {
      error: "Invalid SSN",
      isValid: false,
    };
  }

  return {
    error: "",
    isValid: true,
  };
};
